<template>
    <div id="lottery">
        <!-- 积分和中奖记录 -->
        <div class="flex between" id="shop-gift-info">
            <div class="my_point">
                我的积分：
                <b style="margin-right: 0.6rem">{{ point }}</b>
            </div>
            <!-- 要改 -->
            <a href="javascript:;" class="flex nowrap join_record" @click="gotoRecord">
                <span>参与记录</span>
                <Icon type="ios-arrow-forward" />
            </a>
        </div>
        <!-- 角色切换 -->
        <div class="lottery-bindid" v-if="fictitiousId">
            当前角色：{{ solution_name }}&nbsp;&nbsp;{{
          server_name }}&nbsp;&nbsp;{{ role_name }}&nbsp;&nbsp;<span class="switch-roles" @click="switchrole">切换角色
                <Icon type="ios-arrow-forward" />
            </span>
        </div>
        <!-- 轮盘 -->
        <div class="lottery-box">
            <div class="title draw-title" :title="title">{{ title }}</div>
            <div class="lottery">
                <p style="
                  font-size: 0.6rem;
                  margin-top: 3px;
                  color: #ee6941;
                  font-weight: 700;
                  position: absolute;
                  top: -1.7rem;
                  left: 0;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 10;
                " v-if="lotteryType != 3">
                                剩余抽奖次数:<span style="font-size: 0.8rem; margin-left: 0.2rem">{{ freetime }}</span>
                            </p>
                <div class="lottery-item">
                    <div class="lottery-start">
                        <div class="box" @click="startLottery" v-if="isStart === 0 && isNow == 1">
                            <p>
                                <b>立即<br />抽奖</b>
                            </p>
                            <p style="color: #953920; font-size: 0.6rem" v-if="lotteryType != 3">
                                消耗{{ score }}积分
                            </p>
                        </div>
                        <div class="box gray" v-else-if="isStart === 1 && isNow == 1">
                            <p style="
                  font-size: 0.6rem;
                  margin-top: 3px;
                  color: #ee6941;
                  font-weight: 700;
                  position: absolute;
                  top: -6.7rem;
                  width: 5rem;
                " v-if="lotteryType != 3">
                                剩余抽奖次数
                                <span style="font-size: 0.8rem; margin-left: 0.2rem">{{
                  freetime
                }}</span>
                            </p>
                            <p>
                                <b>立即<br />抽奖</b>
                            </p>
                            <p style="color: #953920; font-size: 0.6rem" v-if="lotteryType != 3">
                                消耗{{ score }}积分
                            </p>
                        </div>
                        <div class="box gray" v-else-if="isNow == 0">
                            <p>
                                <b>立即<br />抽奖</b>
                            </p>
                            <p>未开始</p>
                        </div>
                        <div class="box gray" v-else-if="isNow == 2">
                            <p>
                                <b>抽奖</b>
                            </p>
                            <p>已结束</p>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(item, i) in list" :key="i" :class="i == index ? 'on' : ''">
                            <div class="box">
                                <p>
                                    <img :src="item.icon" />
                                </p>
                                <p>{{ item.title }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 中奖弹窗 -->
            <div class="mask" v-if="showToast"></div>
            <div class="lottery-alert" v-if="showToast">
                <div v-if="this.resultid == 0">
                    <h1>很遗憾</h1>
                    <p>
                        <img :src="this.result.icon" alt />
                    </p>
                </div>
                <div v-else>
                    <h1>恭喜你</h1>
                    <p>
                        <img :src="result.icon" alt />
                    </p>
                    <h2>获得{{ result.title }}</h2>
                </div>
                <div class="btnsave" @click="closealert">确定</div>
                <div style="display: flex; justify-content: center; margin-top: 12px">
                    <van-checkbox v-model="checked" checked-color="#d9b581" icon-size=".7rem"><span
                            style="color: #9e9e9e; margin-left: -0.2rem">跳过动画</span>
                    </van-checkbox>
                </div>
            </div>
        </div>
        <div class="list_rule">
            <!-- 中奖播报 -->
            <p class="ztitle">//////<span>中奖名单</span>//////</p>
            <div class="tborder"></div>
            <div class="winning">
                <div class="content">
                    <!-- 无缝滚动播报 -->
                    <vue-seamless-scroll :data="listData" class="seamless-warp" :class-option="classOption"
                        v-if="this.showbroadcast">
                        <ul class="item">
                            <li v-for="(item, index) in listData" :key="index">
                                <!-- 用户: -->
                                <span class="title" v-text="plusXing(item.nick_name)"></span>
                                <!-- &nbsp;中了&nbsp; -->
                                <span class="date" v-text="item.title"></span>
                            </li>
                        </ul>
                        <ul class="item" v-if="this.listData.length >= 8">
                            <li v-for="(item, index) in listData" :key="index">
                                <!-- 用户: -->
                                <span class="title" v-text="plusXing(item.nick_name)"></span>
                                <!-- &nbsp;中了&nbsp; -->
                                <span class="date" v-text="item.title"></span>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                    <div class="seamless-warp" v-else>暂无中奖记录</div>
                </div>
            </div>
            <p class="ztitle xtitle">//////<span>活动规则</span>//////</p>
            <div class="draw_rules" v-html="explain"></div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: {
            title: [String],
            explain: [String],
            list: [Array],
            juheAppId: [Number, String],
            juheAppName: [String],
            score: [Number, String],
            endTime: [String],
            startTime: [String],
            freetime: [Number],
            lotteryType: [Number, String],
            roleType: [String, Number],
            rollNum: [Number],
        },
        data() {
            return {
                //播报展示与否
                showbroadcast: true,
                resultid: 0,
                result: {},
                isStart: 0,
                listData: [],
                //谢谢惠顾列表
                thanksList: [],
                //转盘抽奖结果的索引
                resultIndex: "",
                index: -1, // 当前转动到哪个位置，起点位置
                count: 8, // 总共有多少个位置
                timer: 0, // 每次转动定时器
                speed: 200, // 初始转动速度
                times: 0, // 转动次数
                cycle: 50, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
                prize: -1, // 中奖位置
                click: true,
                showToast: false, //显示中奖弹窗
                // 是否跳过抽奖动画
                checked: false,
                ottype: 1,
                fictitiousId: null, //角色Id
                role_name: '', //角色名
                solution_name: '', //
                server_name: '',
            };
        },
        computed: {
            lotteryId() {
                return this.$route.query.lottery_id;
            },
            point() {
                return (
                    (this.$store.getters.state.userData &&
                        this.$store.getters.state.userData.point) ||
                    0
                );
            },
            //服务器时间
            now() {
                return new Date(new Date().valueOf() - this.$store.state.differTime);
            },
            isNow() {
                var startTimp = new Date(this.startTime).getTime();
                var endTimp = new Date(this.endTime).getTime();
                var nowTimp = new Date(this.now).getTime();
                if (nowTimp < startTimp) {
                    //未开始
                    return 0;
                } else if (nowTimp >= startTimp && nowTimp <= endTimp) {
                    //进行中
                    return 1;
                } else if (nowTimp > endTimp) {
                    //已结束
                    return 2;
                }
            },
            //播报设置
            classOption() {
                return {
                    step: 0.5,
                    hoverStop: false,
                    openTouch: false,
                };
            },
        },
        mounted() {
            this.getBroadcast();
            this.getpoint();
        },
        methods: {
            //获取播报内容
            getBroadcast() {
                this.$Ajax("shop/activity-lottery-broadcast", {
                    lotteryId: this.lotteryId,
                }).then(rs => {
                    if (rs.code == 200) {
                        this.listData = rs.data || [];
                        if (this.listData.length == 0) {
                            this.showbroadcast = false;
                        } else {
                            this.showbroadcast = true;
                        }
                    } else {
                        this.showbroadcast = false;
                    }
                });
            },
            getpoint() {
                this.$store.dispatch("getUserData", true);
            },
            //前往参与记录
            gotoRecord() {
                this.$router.push({
                    name: 'draw.record',
                    query: {
                        lottery_id: this.lotteryId
                    }
                })
            },
            switchrole() {
                this.$RModal.chooseRole({
                    selection: {
                        juheAppId: this.juheAppId,
                        fictitiousId: this.fictitiousId
                    },
                    onSuccess: (data) => {
                        this.fictitiousId = data.fictitiousId
                        this.role_name = data.role_name
                        this.server_name = data.server_name
                        this.solution_name = data.solution_name
                    }
                })
            },
            //抽奖按钮
            startLottery() {
                if (!this.click) {
                    return;
                }
                if (this.roleType == '2') {
                    this.isStart = 1;
                    this.getLotteryResult('');
                } else {
                    //绑定角色
                    if (this.fictitiousId) {
                        this.isStart = 1;
                        this.getLotteryResult(this.fictitiousId);
                    } else {
                        //未绑定角色
                        this.$RModal.chooseRole({
                            selection: {
                                juheAppId: this.juheAppId,
                                fictitiousId: this.fictitiousId
                            },
                            onSuccess: (data) => {
                                this.fictitiousId = data.fictitiousId
                                this.role_name = data.role_name
                                this.server_name = data.server_name
                                this.solution_name = data.solution_name
                            }
                        })
                    }
                }
            },
            getLotteryResult(id) {
                this.$Ajax('/shop/activity-lottery-join', {
                    lotteryId: this.lotteryId,
                    fictitiousId: id,
                    role_type: this.roleType
                }).then(rs => {
                    if (rs.code == 200) {
                        if (this.freetime > 0) {
                            this.freetime--;
                        } else {
                            if (this.point - this.score >= 0) {
                                this.point = this.point - this.score;
                            }
                        }
                        this.resultid = rs.data.giftId
                        if (rs.data.giftId == 0) {
                            //没中奖  谢谢惠顾 随机位置
                            this.thanksList = [];
                            for (var i = 0; i < this.list.length; i++) {
                                if (this.list[i].id == 0) {
                                    this.thanksList.push(i);
                                }
                            }
                            this.resultIndex =
                                this.thanksList[Math.floor(Math.random() * this.thanksList.length)];
                            this.result = {
                                title: "谢谢参与",
                                icon: require("@/assets/roll/thanks.png"),
                            };
                        } else {
                            //中奖
                            this.resultIndex = this.list.findIndex(
                                value => value.id == rs.data.giftId
                            );
                            this.result = this.list.find(item => {
                                return item.id == rs.data.giftId;
                            });
                        }
                        if (this.checked) {
                            this.noRoll();
                        } else {
                            this.startRoll();
                        }
                    }else {
                      setTimeout(() => {
                        this.isStart = 0;
                      }, 2000)
                    }
                })
            },
            // 不转动
            noRoll() {
                var that = this;
                $(".lottery-item ul").find("li").removeClass("on");
                this.index = this.resultIndex;
                $(".lottery-item ul").find("li").eq(this.resultIndex).addClass("on");
                this.click = true;
                setTimeout(() => {
                    that.showToast = true;
                }, 500);
            },
            // 开始转动
            startRoll() {
                $(".lottery-item ul").find("li").removeClass("on");
                this.times += 1; // 转动次数
                this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
                // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
                if (this.times > this.cycle + 10 && this.prize === this.index) {
                    clearTimeout(this.timer); // 清除转动定时器，停止转动
                    this.prize = -1;
                    this.times = 0;
                    this.speed = 200;
                    this.click = true;
                    var that = this;
                    setTimeout(() => {
                        that.showToast = true;
                    }, 500);
                } else {
                    if (this.times < this.cycle) {
                        this.speed -= 50; // 加快转动速度
                    } else if (this.times === this.cycle) {
                        //const index = parseInt(Math.random() * 10, 0) || 0; // 随机获得一个中奖位置
                        this.prize = this.resultIndex; //中奖位置,可由后台返回
                        if (this.prize > 7) {
                            this.prize = 7;
                        }
                    }
                    if (
                        this.times > this.cycle + 10 &&
                        ((this.prize === 0 && this.index === 7) ||
                            this.prize === this.index + 1)
                    ) {
                        this.speed += 110;
                    } else {
                        this.speed += 20;
                    }
                    if (this.speed < 40) {
                        this.speed = 40;
                    }
                    this.timer = setTimeout(this.startRoll, this.speed);
                }
            },
            // 每一次转动
            oneRoll() {
                let index = this.index; // 当前转动到哪个位置
                const count = this.count; // 总共有多少个位置
                index += 1;
                if (index > count - 1) {
                    index = 0;
                }
                this.index = index;
            },
        },
    };
</script>

<style lang="less" scoped>
    #lottery {
        position: relative;
        z-index: 2;

        #shop-gift-info {
            border: none !important;
            margin: 0 auto;
            padding-top: 0.8rem;

            .my_point {
                background-color: #fff;
                height: 1.2rem;
                line-height: 1.2rem;
                color: #c93b1e;
                padding-left: 1rem;
                font-size: 0.6rem;
                border-radius: 1rem;
                margin-left: -0.8rem;

                b {
                    font-weight: normal;
                    color: #c93b1e;
                }
            }

            .join_record {
                align-items: center;
                color: #c93b1e;
                width: 5rem;
                height: 1.2rem;
                background-color: #fff;
                font-size: 0.6rem;
                padding-left: 0.3rem;
                border-radius: 1rem;
                margin-right: -1.2rem;

                span {
                    margin-left: 0.3rem;
                }
            }

            .flex.reverse {
                flex-flow: nowrap;
            }
        }

        //角色切换
        .lottery-bindid {
            z-index: 10;
            position: absolute;
            top: 5.2rem;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 6px;
            color: #fff;
            font-size: .6rem;

            .switch-roles {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #d9b581;
                cursor: pointer;
            }
        }

        .lottery-box .title {
            position: absolute;
            left: 50%;
            top: -50px;
            transform: translateX(-50%);
            font-size: 2rem;
            font-family: SourceHanSansCN-Heavy-, SourceHanSansCN-Heavy;
            font-weight: 700;
            padding: 2.5rem 0;
            text-align: center;
            color: #fff;
            white-space: nowrap;
            text-transform: uppercase;
            text-shadow: 0px 13px 11px #b50000;
            letter-spacing: 5px;
        }

        //转盘
        .lottery-box {
            position: relative;
            background: url("../../../assets/roll/cc1.png");
            background-size: 99% 100%;
            margin: 0 -1.2rem;
            padding-top: 6rem;
            // overflow: hidden;
            height: 24rem;
            max-width: 552px;
            max-height: 600px;
            margin: 0 auto;
        }

        .lottery {
            animation: changeBg 0.5s ease infinite;
            // overflow: hidden;
            padding: 1rem;
            width: 15.35rem;
            height: 14.4rem;
            // max-width: 356px;
            margin: 0 auto;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            border-radius: 1rem;
            margin-top: 3rem;
            position: relative;
        }

        @keyframes changeBg {
            0% {
                background-image: url("../../../assets/roll/d1.png");
            }

            100% {
                background-image: url("../../../assets/roll/d2.png");
            }
        }

        .lottery .lottery-item {
            height: 320px;
            position: relative;
            margin-left: 4px;
        }

        .lottery .lottery-item ul li {
            width: 33.33333333%;
            position: absolute;
            padding-right: 10px;
            top: 4px;
        }

        .lottery .lottery-item ul li:nth-child(2) {
            left: 33.33333333%;
        }

        .lottery .lottery-item ul li:nth-child(3) {
            left: 66.66666666%;
        }

        .lottery .lottery-item ul li:nth-child(4) {
            left: 66.66666666%;
            top: 4.25rem;
        }

        .lottery .lottery-item ul li:nth-child(5) {
            left: 66.66666666%;
            top: 8.25rem;
        }

        .lottery .lottery-item ul li:nth-child(6) {
            left: 33.33333333%;
            top: 8.25rem;
        }

        .lottery .lottery-item ul li:nth-child(7) {
            left: 0;
            top: 8.25rem;
        }

        .lottery .lottery-item ul li:nth-child(8) {
            left: 0;
            top: 4.25rem;
        }

        .lottery .lottery-item ul li .box {
            height: 3.8rem;
            width: 4.2rem;
            position: relative;
            text-align: center;
            overflow: hidden;
            background: url("../../../assets/roll/c1.png") no-repeat center;
            background-size: 100% 100%;
            border-radius: 0.8rem;
        }

        .lottery .lottery-item ul li .box img {
            display: block;
            height: 39px;
            margin: 0 auto;
            margin-top: 9px;
            max-width: 99%;
        }

        .lottery .lottery-item ul li .box p {
            color: #953920;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
        }

        .lottery .lottery-item ul li.on .box {
            background: url("../../../assets/roll/c3.png") no-repeat center;
            background-size: 100% 100%;
        }

        .lottery .lottery-item ul li.on .box p {
            color: #953920;
        }

        .lottery .lottery-item .lottery-start {
            position: absolute;
            left: 33.33333333%;
            width: 33.33333333%;
            top: 4.25rem;
            padding-right: 10px;
        }

        .lottery .lottery-item .lottery-start .box {
            height: 3.8rem;
            width: 4.2rem;
            font-size: 0.7rem;
            color: #fff;
            cursor: pointer;
            text-align: center;
            overflow: hidden;
            background: url("../../../assets/roll/c2.png") no-repeat center;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .lottery .lottery-item .lottery-start .box p b {
            font-size: 0.8rem;
            line-height: 30px;
            display: block;
            line-height: 22px;
            color: #c93b1e;
            font-weight: normal;
        }

        .lottery .lottery-item .lottery-start .box:active {
            opacity: 0.7;
        }

        // .lottery .lottery-item .lottery-start .box.gray {
        // background: url(https://tradingimage.3975.com/forum/front/lottery-images/bg3.png) no-repeat center;
        // background-size: 100% 100%;
        // }

        .lottery .lottery-item .lottery-start .box.gray:active {
            opacity: unset !important;
        }

        // .lottery .lottery-item .lottery-start .box.gray p {
        //   color: #708abf;
        //   font-weight: bold;
        // }

        .mask {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            position: fixed;
            overflow: hidden;
            z-index: 222;
            top: 0;
            left: 0;
        }

        .lottery-alert {
            width: 15.5rem;
            height: 13.6rem;
            text-align: center;
            z-index: 10000;
            border-radius: 1rem;
            background: #fff;
            padding: 0.9rem;
            position: fixed;
            left: 0;
            right: 0;
            margin: auto;
            top: 50%;
            transform: translateY(-50%);
        }

        .lottery-alert h1 {
            font-size: 1rem;
            font-weight: bold;
            color: #000;
        }

        .lottery-alert img {
            display: block;
            width: 3rem;
            height: 3rem;
            // border-radius: .4rem;
            margin: 0 auto;
            margin-top: 0.2rem;
        }

        .lottery-alert h2 {
            font-weight: normal;
            color: #b87e1c;
            font-size: 0.8rem;
            padding-top: 15px;
        }

        .lottery-alert p {
            color: #666;
            font-size: 16px;
            padding-top: 5px;
        }

        .lottery-alert .btnsave {
            border-radius: 3px;
            box-shadow: none;
            width: 10.35rem;
            height: 2.5rem;
            cursor: pointer;
            line-height: 2.5rem;
            color: #fff;
            margin: 0 auto;
            margin-top: 1rem;
            background-color: #670000;
            font-size: 0.75rem;
            border-radius: 1.25rem;
        }

        //中奖通知
        .winning {
            margin-top: 12px;
            background-color: #fff;
            padding: 12px 0;

            .content {
                display: flex;

                .volume {
                    flex: 2.5;
                    display: flex;
                    justify-content: flex-end;
                    color: #d92b2f;
                }

                //无缝滚动
                .seamless-warp {
                    flex: 7.5;
                    height: 80px;
                    overflow: hidden;

                    ul {
                        li {
                            float: left;
                            width: 100%;
                            word-break: break-all;
                        }
                    }
                }
            }
        }

        .list_rule {
            margin: 1rem;
            max-width: 482px;
            position: relative;
            min-height: 25.25rem;
            background-color: #fff5e9;
            border-radius: 1rem;

            .ztitle {
                font-size: 0.7rem;
                text-align: center;
                color: #d5ac76;
                padding-top: 1.15rem;
                letter-spacing: 3px;

                span {
                    letter-spacing: 1px;
                    color: #ee6941;
                    margin: 0 0.5rem;
                    font-weight: 700;
                }
            }

            .xtitle {
                margin-top: 6.65rem;
            }

            img {
                width: 100%;
            }

            .tborder {
                position: absolute;
                top: 3.1rem;
                left: 50%;
                transform: translateX(-50%);
                width: 15rem;
                max-width: 16.5rem;
                height: 0.5rem;
                background-color: #e9c99f;
                border-radius: 1rem;
            }

            .winning {
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                height: 5.4rem;
                background-color: transparent;
                width: 13.7rem;
                max-width: 15rem;
                margin-top: 3.4rem;
                background-color: #fcebd5;
                border-radius: 0 0 14px 14px;

                .content {
                    padding-left: 0.4rem;
                    height: 100%;

                    .seamless-warp {
                        height: 100%;
                        color: #b87e1c;

                        .item {
                            li {
                                display: flex;
                                justify-content: space-between;

                                .date {
                                    margin-right: 0.55rem;
                                }
                            }
                        }
                    }
                }
            }

            .draw_rules {
                // position: absolute;
                // top: 53%;
                // left: 0;
                width: 100%;
                // height: 40%;
                padding: 0 1.6rem;
                overflow-y: auto;
                line-height: 0.9rem;
                color: #b87e1c;
                margin-top: 0.9rem;
                word-break: break-all;

                &::-webkit-scrollbar {
                    width: 3px;
                }

                &::-webkit-scrollbar-track {
                    background-color: #fff;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #670000;
                }
            }
        }

        @media screen and(min-width: 500px) {
            .list_rule {
                margin: 1rem auto;
            }
        }

        .listrulepc {
            .tborder {
                margin-left: 1.7rem;
            }

            .winning {
                left: 2.3rem;
            }
        }
    }
</style>